import ViolenceType from "../../utils/violence-type.js";
import AggressorRestriction from "../../utils/aggressor-restriction.js";
import {v4} from "uuid";
import AggressorSubpoena from "../../utils/aggressor-subpoena.js";

const populateAddressFromPlace = (address, place) => ({
    id: address.id,
    placeId: place.id,
    city: place.city ? `${place.city} - ${place.state}` : null,
    neighborhood: place.neighborhood || null,
    number: place.number || "",
    address: place.street || null,
    addressType: place.type || null,
    zipCode: place.zipcode || "",
    complement: place.complement || "",
    description: place.name || "",
    latitude: place.latitude || "",
    longitude: place.longitude || "",
    attachId: place.attach_id || null,
});

const NormalizeCitizenData = (data, places) => {
    const addresses = data.addresses?.map((address) => {
        if (!address.placeId) return address;

        const place = places.find((p) => p.id === address.placeId);
        if (!place) return address;

        return populateAddressFromPlace(address, place);
    });

    const attachesDescription = data.attaches.reduce((acc, a) => {
        acc[a.attachId] = a.description ?? null;
        return acc;
    }, {});

    const aggressors = data.aggressors.map(a => ({
        ...a,
        id: v4(),
        violenceTypes: ViolenceType.toOption(a.violenceTypes),
        restrictions: AggressorRestriction.toOption(a.restrictions),
        subpoena: AggressorSubpoena.toOption(a.subpoena),
        vehicles: a.vehicles?.map(v => ({ ...v, id: v4() })),
        hasNoExpiration: a?.hasNoExpiration ?? false
    }));

    const citizen = {
        ...data,
        addresses,
        contactPhones: data.contactPhones.map(c => ({ ...c, id: v4() })),
        vehicles: data.vehicles.map(v => ({ ...v, id: v4() })),
        protectionProgram: data.protectionProgram?.map(p => ({value: p.id, label: p.name, protectiveMeasure: p.protectiveMeasure})),
        protectiveMeasure: data.protectionProgram?.some(p => p.protectiveMeasure) ?? false
    };

    return {
        citizen,
        attaches: data.attaches,
        attachesDescription,
        aggressors,
        status: data.status,
    };
};

export default NormalizeCitizenData;